import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

export interface PortalDsSegmentOption<T extends string = string> {
  value: T;
  label: string;
}

interface PortalDsSegmentedProps<T extends string = string> {
  options: PortalDsSegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  ariaLabel?: string;
}

export function PortalDsSegmented<T extends string = string>({
  options,
  value,
  onChange,
  className,
  ariaLabel,
}: PortalDsSegmentedProps<T>) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={cn(portalDs.segmentGroup, className)}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={cn(portalDs.segment, active && portalDs.segmentActive)}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
